import { render } from "./AddParam.vue?vue&type=template&id=42c3179a"
import script from "./AddParam.vue?vue&type=script&lang=js"
export * from "./AddParam.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__